export const EXPENSES_ENDPOINTS = {
  GET_EXPENSES: "/expenses",
  GET_GROUPED_EXPENSES: "/expenses/grouped",
  GET_RECENT_EXPENSES: "/expenses/recent",
} as const;

export const VOUCHER_EMPLOYEES_ENDPOINTS = {
  GET_VOUCHER_EMPLOYEES: "/voucher_employees",
  SET_PRIORITY_ORDER: "/voucher_employees/set_priority_order",
  RESET_PRIORITY_ORDER: "/voucher_employees/reset_priority_order",
} as const;
